import React, { useEffect, useState } from "react";
import styles from "./ViewGallery.module.css";
import { useNavigate } from "react-router-dom";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import JSZip from "jszip";
import gallery_icon from "../../../assets/images/icons/gallery_ace.svg";
import fav_icon from "../../../assets/images/icons/fav.png";
import fav_filled_icon from "../../../assets/images/icons/fav_filled.png";

import faq_icon from "../../../assets/images/Faqline.png";

import useAxios from "../../Hooks/useAxios";
import GalleryAnnualStorage from "../GalleryAnnualStorage/GalleryAnnualStorage";
import ShareUsingMail from "./ShareUsingMail";

const ViewGallery = () => {
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const image_base_url = `${backend_base}/media/`;
  const frontend_base = process.env.REACT_APP_FRONTEND_URL;
  const [freeAlbums, setFreeAlbums] = useState([]);
  const [passAlbums, setPassAlbums] = useState([]);
  const [annualPass, setAnnualPass] = useState([]);
  const [galleryDetails, setGalleryDetails] = useState([]);
  const [favoritePictures, setFavoritePictures] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [selected, setSelected] = useState(0);
  const [galleryType, setGalleryType] = useState([]);
  const navigate = useNavigate();
  const axios = useAxios();
  const passObj = {
    1: "#EFEEE5",
    2: "#D9DEE3",
    3: "#CCCCCC",
    4: "#E8DBB3",
    5: "#ABC4B9",
  };
  const gray = "#F0F0F0";
  const passLevel = 5;
  const [popUp, setPopUp] = useState(false);
  const [shareGalleryPasswordPopup, setShareGalleryPasswordPopup] =
    useState(false);
  const [shareGalleryLinkPopup, setShareGalleryLinkPopup] = useState(false);
  const [shareUsingMail, setShareUsingMail] = useState(false);
  const [popUpIMGArray, setPopUpIMGArray] = useState([]);
  const [popUpIMGIndex, setPopUpIMGIndex] = useState(-1);
  const [sharedGalleryLink, setSharedGalleryLink] = useState("");

  const handleCopyClick = () => {
    const textField = document.createElement("textarea");
    textField.innerText = sharedGalleryLink;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
    alert("copied");
  };

  const [dataReload, setDataReload] = useState(false);
  useEffect(() => {
    axios
      .get(backend_base + "/shop/gallery")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Albums");
          console.log(res.data);
          setFavoritePictures(res.data.favorite_pictures);
          setFreeAlbums(res.data.free_galleries);
          setPassAlbums(res.data.pass_galleries);
          setAnnualPass(res.data.annual_pass);
          const gals = [];
          const atype = [];
          const gDetails = [];
          for (let album of res.data.pass_galleries) {
            let temp = {
              title: album.name,
              subtitle: "年間パス利用中",
              images: album.images,
            };
            gals.push(temp);
            atype.push("PASS");
            gDetails.push(album);
          }
          for (let album of res.data.free_galleries) {
            let temp = {
              title: album.name,
              subtitle: "",
              images: album.images,
            };
            gals.push(temp);
            atype.push("FREE");
            gDetails.push(album);
          }
          if (gals.length === 0) {
            let temp = {
              title: "Upload",
              subtitle: "",
              images: [],
            };
            gals.push(temp);
            atype.push("UPLOAD");
            gDetails.push({});
          }
          gals.push({
            title: "お気に入り",
            subtitle: "",
            images: res.data.favorite_pictures,
          });
          atype.push("FAVORITE");
          gDetails.push(res.data.favorite_pictures);
          const tempGal = [];
          const tempType = [];
          const tempDetails = [];
          for (let i = 1; gals.length !== 0; i++) {
            if (i !== 1 && i % 6 === 0) {
              tempGal.push(0);
              tempType.push(0);
              tempDetails.push(0);
            } else {
              tempGal.push(gals.shift());
              tempType.push(atype.shift());
              tempDetails.push(gDetails.shift());
            }
          }
          if (tempGal[tempGal.length - 1] !== 0) {
            tempGal.push(0);
            tempType.push(0);
            tempDetails.push(0);
          }
          console.log("TEMPGAL");
          console.log(tempGal);
          console.log(tempType);
          //Handle Authentication
          setGallery(tempGal);
          setGalleryType(tempType);
          console.log("Temp Gallery Type");
          console.log(tempType);
          setGalleryDetails(tempDetails);
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [dataReload]);
  const handleBatchDownload = () => {
    const imgUrls = gallery[selected].images.map(
      (item, index) => image_base_url + item.location
    );
    console.log(imgUrls);
    const zip = new JSZip();

    // Create a promise for each image download
    const promises = imgUrls.map((imgUrl, index) =>
      fetch(imgUrl)
        .then((response) => response.blob())
        .then((blob) => zip.file(`image${index + 1}.jpg`, blob))
    );

    // Wait for all promises to resolve and then generate and download the zip file
    Promise.all(promises).then(() => {
      zip.generateAsync({ type: "blob" }).then((content) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(content);
        link.download = galleryDetails[selected].name + ".zip";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    });
  };
  const changeFavorite = (index, item) => {
    console.log(index);
    console.log(item);
    console.log(gallery[selected].images[index]);
    axios
      .post(backend_base + "/shop/fav-image", {
        image: item.id.toString(),
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Albums");
          console.log(res.data);
          const temp = [];

          // gallery[selected].images[index].is_favorite
          for (let i = 0; i < gallery.length; i++) {
            const tempImages = gallery[i];

            if (i === selected) {
              tempImages.images[index].is_favorite =
                !tempImages.images[index].is_favorite;
              setPopUpIMGArray(tempImages.images);
            }
            temp.push(tempImages);
          }
          setGallery(temp);
          setDataReload((prev) => !prev);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const [popup_gallery_password, set_popup_gallery_password] = useState("");
  const generateSharedGallery = (gallery, password) => {
    let gallery_id = gallery.id;
    console.log(gallery_id);
    console.log(password);

    axios
      .post(backend_base + "/shop/album/share/create", {
        gallery: gallery_id,
        password: password,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Albums");
          console.log(res.data);
          setSharedGalleryLink(frontend_base + res.data.link);
          setShareGalleryLinkPopup(true);
          setShareGalleryPasswordPopup(false);
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  return (
    <>
      <Header />
      {shareGalleryLinkPopup && !shareUsingMail && (
        <div className={styles.share_gallery_link_popup_main}>
          <div className={styles.share_gallery_link_popup_header}>
            合い言葉を設定しました
          </div>
          <div className={styles.share_gallery_link_popup_box}>
            <div className={styles.share_gallery_link_popup_box_inner}>
              <div className={styles.sglpbi_text01}>このギャラリーをシェア</div>
              <div className={styles.sglpbi_div2}>
                <div className={styles.sglpbi_div2_1}>
                  <div className={styles.sglpbi_div2_1_1}>
                    <div
                      onClick={() => {
                        window.open(
                          "https://social-plugins.line.me/lineit/share?url=" +
                            sharedGalleryLink,
                          "_blank"
                        );
                      }}
                      className={styles.sglpbi2111}
                    >
                      <img
                        className={styles.sglpbi2111_line}
                        src={faq_icon}
                        alt="icon"
                      />
                      LINE
                    </div>
                    <div
                      className={styles.sglpbi2112}
                      onClick={() => {
                        setShareUsingMail(true);
                        setShareGalleryLinkPopup(false);
                      }}
                    >
                      Email
                    </div>
                  </div>
                  <div className={styles.sglpbi_div2_1_2}>
                    <input
                      className={styles.sglpbi212_i1}
                      alt="input123"
                      value={sharedGalleryLink}
                    />
                  </div>
                </div>
                <div className={styles.sglpbi_div2_2}>
                  <div
                    className={styles.sglpbi_div22_1}
                    style={{ cursor: "pointer" }}
                    onClick={handleCopyClick}
                  >
                    リンクをコピー
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            onClick={() => {
              setShareGalleryLinkPopup(false);
            }}
            className={styles.share_gallery_link_popup_button02}
          >
            ギャラリーへ戻る
          </div>
        </div>
      )}
      {!shareGalleryLinkPopup && shareUsingMail && (
        <ShareUsingMail
          setShareGalleryLinkPopup={setShareGalleryLinkPopup}
          setShareUsingMail={setShareUsingMail}
          password={popup_gallery_password}
          url={sharedGalleryLink}
        />
      )}
      {shareGalleryPasswordPopup && (
        <div className={styles.share_gallery_popup_main}>
          <div className={styles.share_gallery_popup_text01}>
            ギャラリーをシェアするには「合い言葉」を設定し、URLと合言葉をお伝えください。招待された人がギャラリーを見るために、ユーザー登録を行う必要はありません。
          </div>
          <div className={styles.share_gallery_popup_text02}>
            ギャラリー共有用合い言葉（パスワード）を設定
          </div>
          <input
            className={styles.share_gallery_popup_inputbox}
            value={popup_gallery_password}
            onChange={(e) => {
              set_popup_gallery_password(e.target.value);
            }}
            type="password"
          />
          <div className={styles.share_gallery_popup_text03_div}>
            <div className={styles.share_gallery_popup_text03_01}>
              ・合い言葉には全角文字も利用できます。
            </div>
            <div className={styles.share_gallery_popup_text03_02}>
              ・文字数10字以内
            </div>
          </div>
          <div
            onClick={() => {
              generateSharedGallery(
                galleryDetails[selected],
                popup_gallery_password
              );
            }}
            className={styles.share_gallery_popup_button}
          >
            設定する
          </div>
          <div className={styles.share_gallery_popup_text05}>
            ※合い言葉を忘れた場合は、再度設定しなおしてください。
          </div>
        </div>
      )}
      {popUp && (
        <div className={styles.popUp_main}>
          <div className={styles.popup_img_section}>
            <span
              onClick={() => {
                if (popUpIMGIndex === 0) {
                  setPopUpIMGIndex(popUpIMGArray.length - 1);
                } else {
                  setPopUpIMGIndex(popUpIMGIndex - 1);
                }
              }}
              className={`material-icons ${styles.left_arrow}`}
            >
              keyboard_arrow_left
            </span>
            <div className={styles.popup_img_main}>
              <div
                onClick={() => {
                  setPopUp(false);
                }}
                className={styles.return_section}
              >
                戻る
              </div>
              <img
                className={styles.popup_single_image}
                src={image_base_url + popUpIMGArray[popUpIMGIndex]?.location}
                alt="album_image"
              />
              <div
                onClick={() => {
                  changeFavorite(
                    popUpIMGIndex,
                    gallery[selected].images[popUpIMGIndex]
                  );
                }}
                className={styles.popup_bookmark_icon}
              >
                <img
                  className={styles.popup_fav_icon_custom}
                  src={
                    popUpIMGArray[popUpIMGIndex]?.is_favorite
                      ? fav_filled_icon
                      : fav_icon
                  }
                  alt="icon"
                />
              </div>
            </div>
            <span
              onClick={() => {
                if (popUpIMGIndex === popUpIMGArray.length - 1) {
                  setPopUpIMGIndex(0);
                } else {
                  setPopUpIMGIndex(popUpIMGIndex + 1);
                }
              }}
              className={`material-icons ${styles.right_arrow}`}
            >
              keyboard_arrow_right
            </span>
          </div>
          <div
            onClick={() => {
              const imgUrl =
                image_base_url + popUpIMGArray[popUpIMGIndex].location;
              fetch(imgUrl)
                .then((response) => response.blob())
                .then((blob) => {
                  const url = URL.createObjectURL(blob);
                  const link = document.createElement("a");
                  link.href = url;
                  link.download = "MyAce_single_image.jpg";
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                  URL.revokeObjectURL(url);
                });
            }}
            className={styles.popup_button}
          >
            この写真をダウンロード
          </div>
        </div>
      )}
      {!shareGalleryLinkPopup && !shareUsingMail && (
        <div
          className={styles.main_div}
          style={{
            display:
              popUp || shareGalleryPasswordPopup || shareGalleryLinkPopup
                ? "none"
                : "",
          }}
        >
          <div className={styles.top_header}>
            {/* I need to add not operator in front of both logic */}
            {galleryType[selected] === "PASS" && (
              <div
                className={styles.top_sharing}
                onClick={() => {
                  setShareGalleryPasswordPopup(true);
                }}
              >
                ギャラリーをシェア
                <i className="fa fa-share-alt" aria-hidden="true"></i>
              </div>
            )}
            {/* The following empty div is important. It will make sure that the gallery is in the middle when the share icon is not visible. */}
            {(galleryType[selected] === "FREE" ||
              galleryType[selected] === "FAVORITE") && (
              <div
                className={styles.top_sharing}
                style={{ border: "none", cursor: "default" }}
              ></div>
            )}
            <div className={styles.top_gallery}>
              <div className={styles.gallery_header}>
                <img
                  className={styles.upload_image_gallery_icon}
                  src={gallery_icon}
                  alt="top_gallery"
                />
                <div className={styles.gallery_header_text}>Gallery</div>
              </div>
              <div className={styles.section_header_subtitle}>
                保管期限までに必ずご自身でデータをダウンロードしてください。
              </div>
            </div>
            <div
              // style={{
              //   visibility:
              //     galleryType[selected] === "FREE" ? "hidden" : "visible",
              // }}
              className={styles.top_pass}
            >
              {annualPass &&
                annualPass.pass_type &&
                annualPass.pass_type !== 0 && (
                  <div
                    className={styles.top_pass_main}
                    style={{
                      backgroundColor: passObj[annualPass?.pass_type],
                    }}
                  >
                    <div className={styles.top_pass_text1}>
                      {annualPass.pass_type}年PASS契約中
                    </div>
                    <div className={styles.top_pass_hr}></div>
                    <div className={styles.top_pass_text2}>
                      {"保管期限" + annualPass.expiry_date}
                    </div>
                  </div>
                )}
            </div>
          </div>

          <div className={styles.tab_section}>
            {/* <div className={styles.single_tab_row}></div> */}
            {Array.isArray(gallery) &&
              gallery.length > 0 &&
              gallery.map((item, index) => {
                console.log(item, gallery, "gellery item");
                if (item === 0) {
                  return (
                    <div key={index} className={styles.tab_bottom_border}></div>
                  );
                } else
                  return (
                    <div
                      key={index}
                      onClick={() => {
                        setSelected(index);
                      }}
                      className={styles.single_tab}
                      style={{
                        height: selected === index ? "99px" : "60px",
                        transition: "height 0.3s ease-out",
                        backgroundColor:
                          index === gallery.length - 2
                            ? "white"
                            : galleryType[index] === "FREE"
                            ? "#F0F0F0"
                            : passObj[annualPass?.pass_type],
                        border:
                          index === gallery.length - 2
                            ? "1px solid #707070"
                            : "none",
                        borderBottom: "none",
                      }}
                    >
                      {index === gallery.length - 2 && (
                        <div className={styles.single_tab_fav_row}>
                          <i className="fa fa-bookmark" aria-hidden="true"></i>
                          <div className={styles.fav_spacing}></div>
                          {item.title}
                        </div>
                      )}
                      {index !== gallery.length - 2 && (
                        <div className={styles.single_tab_item_title}>
                          {item.title}
                        </div>
                      )}
                      {selected === index && index !== gallery.length - 2 && (
                        <div className={styles.single_tab_item_subtitle}>
                          {item.subtitle}
                        </div>
                      )}
                    </div>
                  );
              })}
          </div>

          {galleryType[selected] === "UPLOAD" && (
            <div className={styles.free_gallery_not_uploaded_main}>
              <div className={styles.free_gallery_not_uploaded_header}>
                無料のギャラリーをアップロードしてください
              </div>
              <div
                onClick={() => {
                  navigate("/album/create");
                }}
                className={styles.free_gallery_not_uploaded_button}
              >
                無料ギャラリーを作成
              </div>
            </div>
          )}

          {gallery.length > 1 && (
            <div className={styles.images_section}>
              {selected < gallery.length &&
                Array.isArray(gallery[selected].images) &&
                gallery[selected].images.length > 0 &&
                gallery[selected].images.map((item, index) => {
                  console.log(item, gallery[selected], "from 578 line");
                  return (
                    <div
                      className={styles.image_section_single_image_main}
                      key={index}
                      style={{
                        cursor:
                          galleryType[selected] === "FREE"
                            ? "pointer"
                            : "default",
                      }}
                    >
                      <img
                        className={styles.image_section_single_image}
                        src={image_base_url + item.location}
                        alt="album_image"
                        onClick={() => {
                          if (galleryType[selected] === "FREE") {
                            setPopUpIMGIndex(index);
                            setPopUpIMGArray(gallery[selected].images);
                            setPopUp(true);
                          }
                        }}
                      />
                      <div className={styles.image_section_icon}>
                        {/* <i class="far fa-bookmark" aria-hidden="true"></i> */}
                        <img
                          onClick={() => {
                            changeFavorite(index, item);
                          }}
                          className={styles.fav_icon_custom}
                          style={{ cursor: "pointer" }}
                          src={
                            item.is_favorite ||
                            gallery[selected]?.title === "お気に入り"
                              ? fav_filled_icon
                              : fav_icon
                          }
                          alt="icon"
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
          )}

          {selected >= 0 &&
            selected < galleryType.length &&
            galleryType[selected] !== "FAVORITE" &&
            galleryType[selected] !== "FREE" && (
              <>
                <div className={styles.batch_download_section}>
                  <div
                    onClick={() => {
                      handleBatchDownload();
                    }}
                    className={styles.batch_download_button}
                  >
                    写真を一括ダウンロード
                  </div>
                  <div className={styles.download_section_text}>
                    ギャラリーの写真は3ヶ月で自動削除されます。（※成長記録プランを除く）期限内に必ずご自身でダウンロードをお願いします。
                  </div>
                </div>
                <GalleryAnnualStorage hideCard={true} />
              </>
            )}
        </div>
      )}
      <Footer />
    </>
  );
};
export default ViewGallery;
